export const removeSpace = text => {
  if (text) {
    return text.trim() || null;
  }
  return text;
};

export const getNotes = (notes, maxLength) => {
  if (!notes || notes.length === 0) {
    return '-';
  }
  if (notes.length > maxLength) {
    return `${notes.slice(0, maxLength)}...`;
  }
  return notes;
};
